import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';

const InvoiceGrnList = ({ GrnData, itemData, SelectedPO, currencyPrecision, setLazyLoading, setRows, rows }) => {
    const todayDate = new Date().toISOString().substr(0, 10);

    useEffect(() => {
        getGrn();
    }, [itemData]);
    const totalAmount = rows?.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    useEffect(() => {
        getGrn();
    }, [SelectedPO, itemData]);


    const getGrn = async () => {
        const normalize = value =>
            String(value ?? "").trim().toLowerCase();

        try {
            const apiService = new ApiService();

            if (itemData?.pOrderNo) {
                setLazyLoading(true);

                const param = `?POrderNo=${itemData.pOrderNo}`;

                const grnres = await apiService.getApiParamater(
                    "GET_GRN_LIST_INVOICE",
                    param
                );

                // Selected GRNs for the current Purchase Order
                const selectedPO = (itemData?.grnDetails || []).filter(
                    po =>
                        normalize(po?.pOrderNo) ===
                        normalize(itemData?.pOrderNo)
                );

                // Selected GRN numbers
                const selectedGrnNos = new Set(
                    selectedPO.map(detail => normalize(detail?.grnNo))
                );

                // Common mapping function
                const mapGrn = (detail, checked) => ({
                    checked,
                    recordId: detail.grnNo,
                    poNo: detail.pOrderNo,
                    grnNo: detail.grnNo,
                    invoiceNo: detail.invoiceNo,
                    refNo: detail.invoiceRef,
                    grnDate: detail.delivery_Date,
                    currency: detail.currencyCode,
                    amount: detail.amount,
                    invoiceCheck: detail.invoiceActive,
                    status: detail.status
                });

                const apiRows = grnres?.data?.result;

                // If API response is null or empty, bind only selected GRNs
                if (!Array.isArray(apiRows) || apiRows.length === 0) {
                    const selectedRows = selectedPO.map(detail =>
                        mapGrn(detail, 1)
                    );

                    setRows(selectedRows);
                    GrnData(selectedRows);
                    return;
                }

                // Bind API records: checked = 1 if already selected, otherwise 0
                const formattedRows = apiRows.map(detail => {
                    const isSelected = selectedGrnNos.has(
                        normalize(detail?.grnNo)
                    );

                    return mapGrn(detail, isSelected ? 1 : 0);
                });

                // Find selected GRNs missing from API response
                const apiGrnNos = new Set(
                    apiRows.map(detail => normalize(detail?.grnNo))
                );

                const missingSelectedRows = selectedPO
                    .filter(
                        detail =>
                            !apiGrnNos.has(normalize(detail?.grnNo))
                    )
                    .map(detail => mapGrn(detail, 1));

                // Combine API records with any missing selected GRNs
                const combinedRows = [
                    ...formattedRows,
                    ...missingSelectedRows
                ];

                setRows(combinedRows);
                GrnData(combinedRows);

            } else if (SelectedPO) {
                setLazyLoading(true);

                const param = `?POrderNo=${SelectedPO}`;

                const grnres = await apiService.getApiParamater(
                    "GET_GRN_LIST_INVOICE",
                    param
                );

                const formattedRows = (
                    Array.isArray(grnres?.data?.result)
                        ? grnres.data.result
                        : []
                ).map(detail => ({
                    checked: 0,
                    recordId: detail.grnNo,
                    poNo: detail.pOrderNo,
                    grnNo: detail.grnNo,
                    invoiceNo: detail.invoiceNo,
                    refNo: detail.invoiceRef,
                    grnDate: detail.delivery_Date,
                    currency: detail.currencyCode,
                    amount: detail.amount,
                    invoiceCheck: detail.invoiceActive,
                    status: detail.status
                }));

                setRows(formattedRows);
                GrnData(formattedRows);

                if (formattedRows.length === 0) {
                    toast.info(
                        "No GRN has been posted against the selected Purchase Order yet."
                    );
                }
            }
        } catch (error) {
            console.error("Error fetching GRN list:", error);
            toast.error(
                "Unable to retrieve GRN records. Please try again."
            );
        } finally {
            setLazyLoading(false);
        }
    };


    const handleCheckboxChange = (index, checked, row) => {
        setLazyLoading(true)
        const updatedRows = rows?.map((r, i) => ({
            ...r,
            checked: i === index ? (checked ? 1 : 0) : r.checked
        }));
        setRows(updatedRows);
        GrnData(updatedRows);
    };

    return (
        <div>
            <div className='table-container ' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th></th>
                            <th>Grn No</th>
                            <th>PO no</th>
                            <th>Invoice No</th>
                            <th>Ref NO</th>
                            <th>GRN Date</th>
                            <th>Currency</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(rows) && rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 text-center  p-1' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                    <input className='form-check-input' checked={row.checked === 1}
                                        onChange={(e) => handleCheckboxChange(index, e.target.checked, row)}
                                        type="checkbox" style={{ width: "26.81px", height: "26.81px" }} />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.grnNo ? row.grnNo : " "} disabled style={{ width: "220px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.poNo ? row.poNo : " "} disabled style={{ width: "220px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.invoiceNo} disabled style={{ width: "221px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.refNo} disabled style={{ width: "221px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={moment(row.grnDate || todayDate).format('DD-MMM-YYYY')} style={{ width: "220px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.currency} disabled style={{ width: "220px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row.amount || 0).toFixed(currencyPrecision || 0)} style={{ width: "220px" }} /></td>
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            </div>
            <div className='d-flex justify-content-center boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{Number(totalAmount || 0).toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceGrnList;
